import React from 'react';

interface ClipBoardIconProps {
  /**
   * Icon color, defaults to currentColor
   */
  fill?: string;
  /**
   * Icon width
   */
  width?: number;
  /**
   * Icon height
   */
  height?: number;
  /**
   * CSS className
   */
  className?: string;
}

const ClipBoardIcon: React.FC<ClipBoardIconProps> = ({
  fill = 'currentColor',
  width = 24,
  height = 24,
  className = '',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V4C0 3.45 0.195833 2.97917 0.5875 2.5875C0.979167 2.19583 1.45 2 2 2H6.175C6.35833 1.41667 6.71667 0.9375 7.25 0.5625C7.78333 0.1875 8.36667 0 9 0C9.66667 0 10.2625 0.1875 10.7875 0.5625C11.3125 0.9375 11.6667 1.41667 11.85 2H16C16.55 2 17.0208 2.19583 17.4125 2.5875C17.8042 2.97917 18 3.45 18 4V18C18 18.55 17.8042 19.0208 17.4125 19.4125C17.0208 19.8042 16.55 20 16 20H2ZM2 18H16V4H14V6C14 6.28333 13.9042 6.52083 13.7125 6.7125C13.5208 6.90417 13.2833 7 13 7H5C4.71667 7 4.47917 6.90417 4.2875 6.7125C4.09583 6.52083 4 6.28333 4 6V4H2V18ZM9 4C9.28333 4 9.52083 3.90417 9.7125 3.7125C9.90417 3.52083 10 3.28333 10 3C10 2.71667 9.90417 2.47917 9.7125 2.2875C9.52083 2.09583 9.28333 2 9 2C8.71667 2 8.47917 2.09583 8.2875 2.2875C8.09583 2.47917 8 2.71667 8 3C8 3.28333 8.09583 3.52083 8.2875 3.7125C8.47917 3.90417 8.71667 4 9 4Z"
        fill={fill}
      />
      <path
        d="M11.6643 9.77749L8.11429 13.3275L6.68929 11.9025C6.50596 11.7192 6.27263 11.6275 5.98929 11.6275C5.70596 11.6275 5.47263 11.7192 5.28929 11.9025C5.10596 12.0858 5.01429 12.3192 5.01429 12.6025C5.01429 12.8858 5.10596 13.1192 5.28929 13.3025L7.43929 15.4525C7.63929 15.6525 7.87263 15.7525 8.13929 15.7525C8.40596 15.7525 8.63929 15.6525 8.83929 15.4525L13.0643 11.2025C13.2476 11.0025 13.3393 10.7692 13.3393 10.5025C13.3393 10.2358 13.2476 10.0025 13.0643 9.80249C12.8643 9.60249 12.631 9.49833 12.3643 9.48999C12.0976 9.48166 11.8643 9.57749 11.6643 9.77749Z"
        fill={fill}
      />
    </svg>
  );
};

export default ClipBoardIcon;
